import * as commonApi from "@/api/commonPc3341";
import { useCallback, useEffect, useState } from "react";
import { useModel } from "@@/exports";
import {
  postCheckPingan,
  PostCheckPinganResponse,
} from "@/openapi/baob/SupplyPayee";
import { YsResponse } from "@/types";
import { RoleEnum } from "@/constant/business";

interface CommonStateType extends commonApi.BaobanPcGetConfigResponse {
  loading: boolean;
  error: unknown | undefined | Error;
  pinganCheckData: PostCheckPinganResponse | undefined;
}

const initState: CommonStateType = {
  loading: true,
  error: undefined,
  pinganCheckData: undefined,
};

export default () => {
  const { initialState } = useModel("@@initialState");
  const [state, setState] = useState(initState);
  const getCommonConfig = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: undefined }));
    try {
      const res = await commonApi.baobanPcGetConfig();
      setState((s) => ({ ...s, ...res, loading: false }));
    } catch (e) {
      setState((s) => ({ ...s, error: e, loading: false }));
    }
  }, []);

  /**
   * 重置平安结算通数据
   */
  const resetPingAnCheckData = useCallback(
    () => setState((s) => ({ ...s, pinganCheckData: undefined })),
    [],
  );

  const getPingAnCheckData: () => Promise<
    YsResponse<PostCheckPinganResponse> | undefined
  > = useCallback(async () => {
    if (
      !initialState?.currentUser?.mobile ||
      initialState?.currentUser?.roleId !== RoleEnum.BOSS
    ) {
      setState((s) => ({ ...s, pinganCheckData: undefined }));
      return;
    }
    const res = await postCheckPingan({
      baob_mobile_phone: initialState?.currentUser?.mobile,
    });
    setState((s) => ({ ...s, pinganCheckData: res }));
    return res;
  }, [initialState?.currentUser]);

  useEffect(() => {
    getCommonConfig();
  }, [getCommonConfig]);

  useEffect(() => {
    getPingAnCheckData();
  }, [getPingAnCheckData]);

  return {
    ...state,
    getCommonConfig,
    resetPingAnCheckData,
    getPingAnCheckData,
  };
};
